<div class="kt-quick-view">
  <div *ngIf="!loading">
    <ul class="nav nav-pills mb-0" id="pills-tab" role="tablist">
      <li class="nav-item">
        <a class="nav-link active" aria-controls="pills-home" aria-selected="true">
          {{ "HOME.COUNTRIES" | translate }}</a>
      </li>
    </ul>
    <div class="tab-content" id="pills-tabContent">
      <div class="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab">
        <p-accordion [activeIndex]="activeIndex" class="test-country-names">
          <p-accordionTab *ngFor="let item of todaysBetList">
            <ng-template pTemplate="header">
              <img class="flag" [src]="getFlagSlug(item.country)" alt="{{ item.country + ' ' + 'flag' }}"
                onerror="this.src=''" />
              <span class="text-white ml-2" *ngIf="item.country !== 'Great Britain'">{{ item.country }}</span>
              <span class="text-white ml-2" *ngIf="item.country === 'Great Britain'">England</span>
            </ng-template>
            <ng-template pTemplate="content p-0">
              <table class="table table-striped tdBottomBorder mb-0">
                <tbody>
                  <tr *ngFor="let track of item.tracks">
                    <a [routerLink]="trackRacesRouterLink(item.country, track.track, track.eventId)">
                      <td class="w-3 pl-1 pr-0" [ngStyle]="{'min-width': '34px'}">
                        <img src="../../../../assets/media/icons/{{getRaceType(track.races[0],'icon')}}.webp"
                          [alt]="getRaceType(track.races[0],'icon')" [pTooltip]="getRaceType(track.races[0],'tooltip')"
                          tooltipPosition="right" />
                      </td>
                      <td>
                        <div class="text-ellipsis test-country-races" [ngStyle]="{width: '100px'}">
                          <span *ngIf="track.pmuReunion" class="pmu-reunion mr-1">R{{ track.pmuReunion }}</span>{{ track.track }}
                        </div>
                      </td>
                      <td class="text-right">
                        {{ getLocalDate(track.races[0]) }}
                      </td>
                    </a>
                  </tr>
                </tbody>
              </table>
            </ng-template>
          </p-accordionTab>
        </p-accordion>

      </div>
    </div>
  </div>
</div>
